import GenericError from './GenericError';
import { FC } from 'react';

const FiveZeroZeroError: FC = () => {
  return (
    <GenericError
      imageUrl={'/assets/500_comp.png'}
      imageHeight={244}
      imageWidth={224}
      title={'Internal Server Error.'}
    />
  );
};

export default FiveZeroZeroError;
